/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MediaBlogPostsListRequest } from '../../models/media-blog-posts-list-request';
import { MediaBlogPostsResponse } from '../../models/media-blog-posts-response';

export interface ListMediaBlogPosts$Params {
  page: number;
  pageSize: number;
      body: MediaBlogPostsListRequest
}

export function listMediaBlogPosts(http: HttpClient, rootUrl: string, params: ListMediaBlogPosts$Params, context?: HttpContext): Observable<StrictHttpResponse<MediaBlogPostsResponse>> {
  const rb = new RequestBuilder(rootUrl, listMediaBlogPosts.PATH, 'post');
  if (params) {
    rb.path('page', params.page, {});
    rb.path('pageSize', params.pageSize, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MediaBlogPostsResponse>;
    })
  );
}

listMediaBlogPosts.PATH = '/rest/media/blog-post/{page}/{pageSize}';
